import React, { useState, useRef } from "react";

const OTPInput = ({ onChange }) => {
  const [otp, setOtp] = useState(Array(6).fill(""));
  const inputs = useRef([]);

  const handleChange = (index, value) => {
    if (!/^\d*$/.test(value)) return; // Allow only digits

    const updatedOtp = [...otp];
    updatedOtp[index] = value.slice(-1); // Take only the last digit
    setOtp(updatedOtp);
    onChange(updatedOtp.join(""));

    // Focus the next input
    if (value && index < 5) {
      inputs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (index, event) => {
    if (event.key === "Backspace" && !otp[index] && index > 0) {
      inputs.current[index - 1]?.focus();
    }
  };

  const handlePaste = (event) => {
    const pasteData = event.clipboardData.getData("Text").slice(0, 5);
    if (!/^\d+$/.test(pasteData)) return; // Allow only digits

    const updatedOtp = pasteData.split("");
    for (let i = 0; i < 6; i++) {
      otp[i] = updatedOtp[i] || "";
    }
    setOtp([...otp]);
    onChange(otp.join(""));

    // Focus the last non-empty input
    const nextIndex = pasteData.length - 1;
    inputs.current[nextIndex]?.focus();
  };

  return (
    <div style={{ display: "flex", gap: "9px" }}>
      {otp.map((digit, index) => (
        <input
          key={index}
          type="text"
          maxLength={1}
          value={digit}
          onChange={(e) => handleChange(index, e.target.value)}
          onKeyDown={(e) => handleKeyDown(index, e)}
          onPaste={handlePaste}
          ref={(el) => (inputs.current[index] = el)}
          style={{
            background:"#DDDEE4",
            width: "45.26px",
            height: "46px",
            textAlign: "center",
            border: "1px solid #ccc",
            borderRadius: "4px",
          }}
        />
      ))}
    </div>
  );
};

export default OTPInput;
